/**
 * Representation of a CSS Value
 *
 * @remarks
 * * T: a string representation of the type stored in the value,
 *      e.g. "length", "color", …
 * * CALC: whether the numeric values in this may include calculation or not.
 *         When CALC is true, the value hasn't been resolved. It does not
 *         necessarily contain calculation; when CALC is false, the value has
 *         been fully resolved and is guaranteed without calculations.
 * * R: a string representation of the type stored in the resolved value.
 *      This differs from T, typically, for dimension-percentage values that
 *      are resolved as dimensions only.
 * * PR: a string representation of the type stored in the partially resolved value.
 *
 * @public
 */
export class Value {
    _type;
    _hasCalculation;
    constructor(type, hasCalculation) {
        this._type = type;
        this._hasCalculation = hasCalculation;
    }
    get type() {
        return this._type;
    }
    hasCalculation() {
        return this._hasCalculation;
    }
    partiallyResolve(resolver) {
        return this.resolve(resolver);
    }
    toJSON() {
        return { type: this._type };
    }
}
/**
 * @public
 */
(function (Value) {
    function isValue(value, type) {
        return (value instanceof Value && (type === undefined || value.type === type));
    }
    Value.isValue = isValue;
    /**
     * @internal
     */
    function hasCalculation(...values) {
        return values.some((value) => value.hasCalculation());
    }
    Value.hasCalculation = hasCalculation;
})(Value || (Value = {}));
//# sourceMappingURL=value.js.map